module.exports = __webpack_public_path__ + "static/media/bad.f6096eaf.gif";